module.exports = __webpack_public_path__ + "static/media/roi.f0c128c8.png";